import reviews from './reviews';
import ratings from './ratings';
import widgetInfo from './widget-info';

const root = {
	reviews,
	ratings,
	widgetInfo
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js